import { Injectable } from '@angular/core';
import * as alertify from 'alertifyjs';

@Injectable({
  providedIn: 'root',
})
export default class AlertifyHelper {
  // static doSomething(val: string) { return val; }
  // static doSomethingElse(val: string) { return val; }

  constructor() {}

  success(msg: any = null, time: any = 2.5, position: string = 'center'): void {
    let val_msg = msg != null ? msg : 'Message Success';
    let val_time = time != null ? time : 2.5;
    alertify.set('notifier', 'delay', val_time);
    alertify.set('notifier', 'position', 'top-' + position);
    alertify.success(val_msg);
  }

  warning(msg: any = null, time: any = 2.5, position: string = 'center'): void {
    let val_msg = msg != null ? msg : 'Message Warning';
    let val_time = time != null ? time : 2.5;
    alertify.set('notifier', 'delay', val_time);
    alertify.set('notifier', 'position', 'top-' + position);
    alertify.warning(val_msg);
  }

  error(msg: any = null, time: any = 2.5, position: string = 'right'): void {
    let val_msg = msg != null ? msg : 'Message Error';
    let val_time = time != null ? time : 2.5;
    alertify.set('notifier', 'delay', val_time);
    alertify.set('notifier', 'position', 'top-' + position);
    alertify.error(val_msg);
  }
}
